export function digits(value: string): string {
  return value.replace(/\D/g, "");
}

export function formatCnpjInput(value: string): string {
  const clean = digits(value).slice(0, 14);
  return clean
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2");
}

export function formatCpfInput(value: string): string {
  const clean = digits(value).slice(0, 11);
  return clean
    .replace(/^(\d{3})(\d)/, "$1.$2")
    .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d{1,2})$/, ".$1-$2");
}

export function formatCurrency(value?: number): string {
  if (value === undefined || Number.isNaN(value)) return "Não informado";
  return value.toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 2 });
}

/** Detecta o tipo provável do termo digitado no modo automático. */
export function detectQueryKind(query: string): "cnpj" | "cpf" | "name" {
  const clean = digits(query);
  const isMostlyDigits = clean.length > 0 && clean.length >= digits(query).length && /^[\d./\s-]*$/.test(query.trim());
  if (isMostlyDigits && clean.length === 14) return "cnpj";
  if (isMostlyDigits && clean.length === 11) return "cpf";
  return "name";
}

export function statusTone(status?: string): "ok" | "bad" | "warn" | "muted" {
  if (!status) return "muted";
  const clean = status
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
  if (clean.includes("ativa")) return "ok";
  if (clean.includes("baixada") || clean.includes("nula")) return "bad";
  if (clean.includes("suspensa") || clean.includes("inapta")) return "warn";
  return "muted";
}

/** Remove CPFs embutidos em razões sociais de MEI para exibição mais limpa. */
export function cleanDisplayName(name: string): string {
  return name.replace(/\s*\d{11}\s*/g, " ").replace(/\s{2,}/g, " ").trim() || name;
}

const ABBREVIATION = /\b[a-zà-ÿ]{1,4}$/i;

/**
 * A Receita publica descrições com trechos soltos em caixa baixa depois de "-" ou ".".
 * Sobe a primeira letra da frase e a de cada trecho isolado por um separador,
 * preservando abreviações curtas ("Ltda. de..." continua como está).
 */
export function sentenceCase(value?: string): string {
  const source = (value ?? "").trim();
  if (!source) return "";
  const first = source[0].toLocaleUpperCase("pt-BR") + source.slice(1);
  return first.replace(
    /([-–—;:]\s+|\.\s+)([a-zà-ÿ])/g,
    (match, separator: string, letter: string, offset: number, whole: string) => {
      if (separator.startsWith(".") && ABBREVIATION.test(whole.slice(0, offset))) return match;
      return `${separator}${letter.toLocaleUpperCase("pt-BR")}`;
    },
  );
}
